import { Dialog } from "@progress/kendo-react-dialogs";
import React, { useEffect, useState } from "react";
import { NotificationManager } from "src/util/notify";
import { orderBy } from "@progress/kendo-data-query";
import Loader from "../../control-components/loader/loader";
import ErrorHelper from "../../helper/error-helper";
import DropDownKendoRct from "../../control-components/drop-down/drop-down";
import { fileDocumentService } from "../../services/fileDocumentTemplateService";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";

function AssignTemplateToClinic({
  onClose,
  documentTemplateId,
  sourceRegionId,
  checkedTemplates,
  getAllDefaultDocumentTemplates

}) {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState("");
  const [settingError, setSettingError] = useState(false);
  const [allclinics, setAllClinics] = useState([]);

  let [fields, setFields] = useState({
    clinicName: "",
  });

  useEffect(() => {
    getAllClinic();
  }, []);

const getAllClinic = async () => {
  setLoading(true);

  const payload = {
    region: sourceRegionId || 0,
    isActive: true,
    state: 0,
    isRCM: true,
    customerStatusId: 0,
  };

  await fileDocumentService
    .getAllClinic(payload)
    .then((result) => {
      setLoading(false);
      let staffAuditActions = result.resultData;
      setAllClinics(staffAuditActions);
    })
    .catch((error) => {
      setLoading(false);
      NotificationManager.error(error.message);
    });
};

  const assignTemplateclinic = async () => {
    setLoading(true);
    await fileDocumentService
      .assignTemplate(fields, checkedTemplates, sourceRegionId)
      .then((result) => {
        setLoading(false);
        NotificationManager.success("Template assigned successfully");
        onClose({ updated: true });
        getAllDefaultDocumentTemplates()
      })
      .catch((error) => {
        setLoading(false);
        NotificationManager.error(error);
      });
  };

  const handleValidation = () => {
    let errors = {};
    let formIsValid = true;

    if (!fields.clinicName) {
      formIsValid = false;
      errors["clinicName"] = ErrorHelper.FIELD_BLANK;
    }

    setErrors(errors);
    return formIsValid;
  };

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setFields({
      ...fields,
      [name]: value,
    });
  };

  const handleSubmit = (event) => {
    setSettingError(true);
    if (handleValidation()) {
      assignTemplateclinic();
    }
  };

  return (
    <Dialog
      onClose={onClose}
      title="Assign Template to Clinic"
      height={550}
      width={800}
    >
      <div className="edit-Service-popup dialog-editp y-3 header-blue">
        {loading == true && <Loader />}
        <div className="mx-3">
          <div className="row align-items-center">
            <div className="col-12 mb-3 mt-3">
              <DropDownKendoRct
                validityStyles={settingError}
                filterable={true}
                label="Clinic"
                onChange={handleChange}
                data={allclinics}
                value={fields?.clinicName}
                textField="clinicName"
                name="clinicName"
                dataItemKey="id"
                suggest={true}
                required={true}
                error={!fields.clinicName && errors.clinicName}
              />
            </div>
          </div>
          <Grid
            data={checkedTemplates}
            checkboxElement
            style={{
              height: "300px",
            }}

          >
            <GridColumn
              className="cursor-default"
              field="id"
              title="Template ID"
              cells={{
                data: (props) => {
                  let field = props?.dataItem
                  return <td className="cursor-default">{field?.id}</td>;
                }
              }}
            />
            <GridColumn
              className="cursor-default"
              field="templateName"
              title="Template Name"
              cells={{
                data: (props) => {
                  let field = props?.dataItem
                  return <td className="cursor-default">{`${field?.templateName}`}</td>;
                }
              }}
            />
          </Grid>
        </div>
      </div>
      <div className="d-flex my-4">
        <button
          className="green-btn  btn-primary border-0 mx-3 btn-space"
          onClick={handleSubmit}
        >
          Submit
        </button>
        <button className="btn grey-secondary btn-space " onClick={onClose}>
          Cancel
        </button>
      </div>
    </Dialog>
  );
}
export default AssignTemplateToClinic;
